import {getCurrentDay} from "../../../Model/Models";

/**
 * @Author      Jhovanny Fragoso Marquez
 * @JobTitle    Frontend Developer
 * @Email       jfragoso@ibl.mx
 */

export const MANAGE_CONTRACTORS_MODEL = {
    id: null,
    waitTime: null,
    renewal: "",
    frequencyValue: "",
    timeUnit: null,
    leadDays: "",
    startDate: null,//custom

    start: null,//one time only || custom range
    end: null,//one time only || custom range
    startLeadAwareRange: null,//one time only || custom range
    endLeadAwareRange: null,//one time only || custom range
    startNextRange: null,//one time only || custom range
    endNextRange: null,//one time only || custom range
    isValidOneTime: function () {
        return this.start != null;
    },
    isValidCustom: function () {
        return this.frequencyValue != null && this.frequencyValue !== "" &&
            this.timeUnit != null  && this.startDate != null   &&
            this.leadDays != null && this.leadDays !== "";
    },
    setSettings: function (data) {
        const currentDay = getCurrentDay();
        const start = data?.startDatePeriod ? data?.startDatePeriod : currentDay;

        return {
            ...this,
            id: data.id,
            waitTime: data.waitTime,
            renewal: data.renewal,
            frequencyValue: data.frequencyValue,
            timeUnit: data.timeUnit,
            leadDays: data.leadDays,
            startDate: start,
            start: start,
            end: null
        }
    },
    setPeriodRange: function (data) {
        const currentDay = getCurrentDay();
        const start = data?.[0]?.startDate ? data?.[0]?.startDate : currentDay;
        const end = data?.[0]?.endDate ? data?.[0]?.endDate : currentDay;
        let startLeadAwareRange = data?.[1]?.startDate ? data?.[1]?.startDate : currentDay;
        let endLeadAwareRange = data?.[1]?.endDate ? data?.[1]?.endDate : currentDay;
        const startNextRange = data?.[2]?.startDate ? data?.[2]?.startDate : currentDay;
        const endNextRange = data?.[2]?.endDate ? data?.[2]?.endDate : currentDay;

        startLeadAwareRange = new Date(start).getTime() === new Date(startLeadAwareRange).getTime() ? startNextRange : startLeadAwareRange ;
        endLeadAwareRange = new Date(end).getTime() === new Date(endLeadAwareRange).getTime() ? endNextRange : endLeadAwareRange ;

        return {
            ...this,
            start: start,
            end: end,
            startLeadAwareRange: startLeadAwareRange,//one time only || custom range
            endLeadAwareRange: endLeadAwareRange,//one time only || custom range
            startNextRange: startNextRange,//one time only || custom range
            endNextRange: endNextRange,//one time only || custom range
        }
    }
}
